// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__35ePN","icon":"style_icon__1Rup8","title":"style_title__cuakh","description":"style_description__1hLfN","alternate":"style_alternate__2BCFu"};